// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "ad2866b8" + "." + "da7517a88118b074" + ".js";
};